import React from 'react';
import PropTypes from 'prop-types';
import './LoadingScreen.css';

/**
 * Simple LoadingScreen Component for AgriIntel with white background
 */
const LoadingScreen = ({ message = "Loading AgriIntel workspace" }) => {
  return (
    <div className="agri-loading-container" role="status" aria-live="polite">
      <div className="agri-spinner" />
      <p className="agri-loading-text">
        {message}
        <span className="agri-loading-dots">
          <span>.</span><span>.</span><span>.</span>
        </span>
      </p>
    </div>
  );
};

LoadingScreen.propTypes = {
  message: PropTypes.string,
};

export default React.memo(LoadingScreen);
